<kendo-formfield class="form-field" [formGroup]="formgroup!">
    <kendo-floatinglabel [text]="t7eLabel">
        <kendo-multiselect #depts class="ddStatus" formControlName="status" [data]="statuses" [textField]="statusTextFieldName"
            valueField="id" name="statuses" [checkboxes]="true" [autoClose]="false" fillMode="flat"
            [ngStyle]="style">
        </kendo-multiselect>
    </kendo-floatinglabel>
</kendo-formfield>